export const RecommendationSortType = {
  EVALUATION: 'evaluation',
  CREATED_AT: 'createdAt',
  NAME: 'name',
} as const

export type RecommendationSortTypeValue =
  (typeof RecommendationSortType)[keyof typeof RecommendationSortType]

export const RecommendationSortTypeLabel: { [key: string]: string } = {
  [RecommendationSortType.EVALUATION]: 'おすすめ順',
  [RecommendationSortType.CREATED_AT]: '新着順',
  [RecommendationSortType.NAME]: '名前順',
}
